import { atom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { atomWithDefault } from 'jotai/utils';
import { reduxAtom } from '../../../../../../jotai/redux-atoms';
import {
	determineIsVanityFacet,
	getRangesByCategory,
	getVanityFacetValues,
} from './utils';

export const startingPriceFilterConfigAtom = atomWithDefault((get) => {
	const state = get(reduxAtom);
	const categoryCode = state.category.code;

	return getRangesByCategory(categoryCode);
});

const appliedMinMaxAtom = atom((get) => {
	const state = get(reduxAtom);
	const applied = state.search.filterPills.applied;
	const categoryCode = state.category.code;
	const isVanityFacet = determineIsVanityFacet(categoryCode, applied);

	return isVanityFacet
		? getVanityFacetValues[`${categoryCode}-${applied[0].value}`]
		: applied.reduce(
				(acc, filter) => {
					if (filter.categorySlug === 'minPrice') {
						acc.minInput = filter.value;
					}
					if (filter.categorySlug === 'maxPrice') {
						acc.maxInput = filter.value;
					}
					return acc;
				},
				{ minInput: '', maxInput: '' },
			);
});

export const startingPriceFilterAtom = atomWithDefault((get) => {
	const [startingMin, startingMax] = get(startingPriceFilterConfigAtom);
	const { minInput, maxInput } = get(appliedMinMaxAtom);
	return {
		minInput,
		maxInput,
		minVal: Number(minInput) || startingMin,
		maxVal: Number(maxInput) || startingMax,
	};
});

export const maxInputAtom = focusAtom(startingPriceFilterAtom, (optic) =>
	optic.prop('maxInput'),
);
export const minValAtom = focusAtom(startingPriceFilterAtom, (optic) =>
	optic.prop('minVal'),
);
export const maxValAtom = focusAtom(startingPriceFilterAtom, (optic) =>
	optic.prop('maxVal'),
);
export const minInputAtom = focusAtom(startingPriceFilterAtom, (optic) =>
	optic.prop('minInput'),
);

export const isDirtyMinAtom = atom((get) => {
	const minInput = get(minInputAtom);
	const applied = get(appliedMinMaxAtom);
	return minInput !== applied.minInput;
});

export const isDirtyMaxAtom = atom((get) => {
	const maxInput = get(maxInputAtom);
	const applied = get(appliedMinMaxAtom);
	return maxInput !== applied.maxInput;
});

export const isDirtyMinMaxAtom = atom((get) => {
	return get(isDirtyMinAtom) || get(isDirtyMaxAtom);
});

export const resetStagedMinMaxAtom = atom(null, (get, set) => {
	const [startingMin, startingMax] = get(startingPriceFilterConfigAtom);
	const { minInput, maxInput } = get(appliedMinMaxAtom);
	if (get(isDirtyMinAtom)) {
		set(minInputAtom, minInput);
		set(minValAtom, Number(minInput) || startingMin);
	}
	if (get(isDirtyMaxAtom)) {
		set(maxInputAtom, maxInput);
		set(maxValAtom, Number(maxInput) || startingMax);
	}
});

export const clearAtom = atom(null, (get, set) => {
	const [startingMin, startingMax] = get(startingPriceFilterConfigAtom);
	set(minValAtom, startingMin);
	set(maxValAtom, startingMax);
	set(minInputAtom, '');
	set(maxInputAtom, '');
});
